import { Injectable } from "@angular/core";
import { ArrayClientRepository } from "./abstract/array.client.repository";
import { ClientService } from "../services/client.service";
import { Script } from "../types/Script/Script";

@Injectable({
  providedIn: "root",
})
export class ScriptRepository extends ArrayClientRepository<Script> {
  constructor(clientService: ClientService) {
    super(clientService, "schemas.schHSScripts.records", "scriptID");
  }
}
